import { differenceInDays } from 'date-fns';
import {
  OnboardingAnswers,
  OnboardingSteps,
} from 'shared/types/onboarding-answers';

const key = 'onboarding-answers';

const defaultAnswers: OnboardingAnswers = {
  lastShownStep: OnboardingSteps.Welcome,
};

export const getOnboardingAnswers = () => {
  const answersString = window.localStorage.getItem(key);
  let answers: OnboardingAnswers;
  try {
    answers = JSON.parse(answersString ?? '') ?? {};

    // If answers are older than 7 days, reset them
    if (
      answers.updatedAt &&
      differenceInDays(answers.updatedAt, new Date()) > 7
    ) {
      answers = defaultAnswers;
    }
  } catch (e) {
    answers = defaultAnswers;
  }

  return answers;
};

export const setOnboardingAnswers = (answers: Partial<OnboardingAnswers>) => {
  const updatedAnswers = {
    ...getOnboardingAnswers(),
    ...answers,
    updatedAt: new Date(),
  };

  window.localStorage.setItem(key, JSON.stringify(updatedAnswers));
};

export const clearOnboardingAnswers = () => window.localStorage.removeItem(key);
